// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollable{overflow-y:auto;overflow-x:hidden;height:75vh}", ""]);
// Exports
module.exports = exports;
